import React from 'react'
import PropTypes from 'prop-types'
export default class InputRowArabic extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      mouseOver: false
    }
  }

  render () {
    return (
      <div className="wrapper">
        <div className="input-control" dir="rtl">
          <span className="label" dir="rtl">{this.props.rowName}</span>
          <span className="label">{this.props.rowName}<label style={{ color: 'red' }}>{this.props.required}</label></span>
          <div className="input-box">
            <input
              type={this.props.name}
              id={this.props.rowName}
              value={this.props.value}
              dir="rtl"
              writingDirection = "rtl"
              secureTextEntry="false"
              textAlign= "rtl"
              onChange={
                (e) => this.props.onChange(e.target.value)
              }
              onKeyPress={(e) => this.props.onKeyPress ? this.props.onKeyPress(e) : null}
            />
          </div>
        </div>
        <div style={{ display: this.props.errMsg ? 'block' : 'none', width: '100%', marginLeft: 5, paddingBottom: 5 }}><span style={{ color: 'red', fontSize: 12 }}>{this.props.errMsg}</span></div>
      </div>

    )
  }
}
InputRowArabic.propTypes = {
  rowName: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  onKeyPress: PropTypes.func,
  errMsg: PropTypes.string

}
